export default __webpack_public_path__ + "static/media/flag-icon-red.ce1a6a04.svg";